var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title")))]),
      _c(
        "w-card-content",
        [
          _c("w-input-number", {
            attrs: { fancy: "", label: _vm.$ct("label"), decimals: "0" },
            model: {
              value: _vm.records,
              callback: function ($$v) {
                _vm.records = $$v
              },
              expression: "records",
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-button", { staticClass: "cancel", on: { click: _vm.cancel } }, [
            _vm._v(_vm._s(_vm.$ct("common.cancel"))),
          ]),
          _c("w-spacer"),
          _c("w-button", { on: { click: _vm.confirm } }, [
            _vm._v(_vm._s(_vm.$ct("common.confirm"))),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }